import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { connect } from 'react-redux';

import { Typography } from '@comparethemarketau/manor-typography';
import { Link } from '@comparethemarketau/manor-link';

import { getBreakpointFromManor } from 'ctm-components';

import { FiltersRefineModal } from '../../filters/common/filters_refine_modal';

const useStyles = createUseStyles((theme) => ({
    container: {
        marginTop: '2.4rem',
        marginBottom: '8.3rem'
    },
    title: {
        marginBottom: '2.4rem'
    },
    bold: {
        fontWeight: theme.fontWeight.bold
    },
    updatingButton: {
        display: 'inline'
    },
    text: {
        extend: ({ breakpoint }) => {
            if (breakpoint === 'sm' || breakpoint === 'md') {
                return {
                    fontSize: theme.fontSize.lg
                };
            }
            if (breakpoint === 'lg') {
                return {
                    fontSize: theme.fontSize.xl
                };
            }
            return {
                fontSize: theme.fontSize.base
            };
        }
    }

}));

const _FiltersChangesNotice = ({ isCoverTypeChanged, isExcessChanged }) => {
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, breakpoint });

    return (
        <div className={classNames('test-emptyState-filtersChangesNotice', classes.container)}>
            <div className={classNames(classes.title)}>
                <Typography component={'span'} className={classNames(classes.text)} align="center">
                    {'You made changes to the '}
                    <Typography component={'span'} className={classNames(classes.bold, classes.text)}>{isCoverTypeChanged ? 'cover type' : 'excess amount'}</Typography>
                    {
                        (isCoverTypeChanged && isExcessChanged) && (
                            <>
                                {' and '}
                                <Typography component={'span'} className={classNames(classes.bold, classes.text)}>excess amount</Typography>
                            </>
                        )
                    }
                    {'.'}
                </Typography>
            </div>
            <Typography component={'span'} align="center" className={classNames(classes.text)}>
                {'Adjust your search by '}
                {
                    breakpoint === 'xs' ? (
                        <FiltersRefineModal className={classes.updatingButton}
                            button={
                                (handleClick) => (
                                    <Link
                                        handleClick={handleClick}
                                        underline="none"
                                        trackingLabel={'Button for refine filters'}
                                    >
                                        {'updating your filters'}
                                    </Link>
                                )
                            }
                        />
                    )
                        : 'updating the filters above.'
                }
            </Typography>
        </div>
    );
};

_FiltersChangesNotice.propTypes = {
    isCoverTypeChanged: PropTypes.bool,
    isExcessChanged: PropTypes.bool
};

// see packages/ctm-app/client/sagas/filters.js
const mapStateToProps = (state) => {
    const actions = state.getIn('page.applyStagedFilters'.split('.'));
    const isCoverTypeChanged = actions && actions.some((action) => action.filterType === 'coverType');
    const isExcessChanged = actions && actions.some((action) => action.filterType === 'requestedExcess');
    return {
        isCoverTypeChanged,
        isExcessChanged
    };
};

const FiltersChangesNotice = connect(mapStateToProps)(_FiltersChangesNotice);

export { FiltersChangesNotice, _FiltersChangesNotice };
